import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';
import './styles/dark-mode.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/modal-layer.css';
import './styles/compact-content.css';
import './styles/inventory-unified.css';
import './styles/button-unified.css';
import './styles/globalVars';
import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';
import Swal from 'sweetalert2';
import ErrorBoundary from './components_shared/ErrorBoundary';

// ── Brand-theme all SweetAlert2 calls globally ──────────────────────────────
// ES modules are singletons: mutating Swal.fire here affects every import
// across the entire app, so no per-file changes are needed.
const _swalFire = Swal.fire.bind(Swal);
Swal.fire = function (opts, text, icon) {
  let options;
  if (opts && typeof opts === 'object') {
    options = opts;
  } else {
    options = {};
    if (opts  !== undefined) options.title = opts;
    if (text  !== undefined) options.text  = text;
    if (icon  !== undefined) options.icon  = icon;
  }
  const { customClass: callerCC, ...rest } = options;
  return _swalFire({
    confirmButtonColor: '#10ac84',
    cancelButtonColor:  '#64748b',
    customClass: {
      popup:         'stbb-swal-popup',
      confirmButton: 'stbb-swal-confirm',
      cancelButton:  'stbb-swal-cancel',
      denyButton:    'stbb-swal-deny',
      title:         'stbb-swal-title',
      htmlContainer: 'stbb-swal-body',
      actions:       'stbb-swal-actions',
      timerProgressBar: 'stbb-swal-progress',
      ...(callerCC || {}),
    },
    ...rest,
  });
};

// Expose globals used across legacy components
// Check if window is defined (for environments like testing or server-side rendering)
if (typeof window !== 'undefined') {
  window.Swal = Swal;
  window.$ = window.jQuery = $;
  
  // Set theme from localStorage immediately to avoid layout flash
  const savedTheme = localStorage.getItem('theme');
  if (savedTheme === 'dark') {
    document.body.classList.add('dark-mode');
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
